<template>
  <div id="notifelement" class="notifelement">
    <div class="new-message-box">
      <div class="new-message-box-success">
        <div class="info-tab tip-icon-success" title="error"><i></i></div>
        <div class="tip-box-success">
          <h4>Registration success</h4>
          <p>
            We sent you an activation code. Before login, please check your inbox or spam email and
            click on the link to verify.
          </p>
          <br>
          <div class="text-center">
            <a href="/user-account" class="button-read-more">Login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataprop"],
  data() {
    return {
      url: "",
      data: {},
    };
  },
  mounted: function () {
    var target = document.querySelector("#notifelement");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
      if (!_.isEmpty(this.dataprop)) this.data = this.dataprop;
      this.data.fullname = `${this.data.title} ${this.data.first_name} ${this.data.last_name}`;
      if (this.data.post_nominal_letter) {
        this.data.fullname = `${this.data.fullname} ${this.data.post_nominal_letter}`;
      }
    },
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
  },
};
</script>
<style>
#copy-rek {
  font-size: 1.5em;
}
.tooltip.fade.top.in {
  display: inline-block !important;
  top: -15px !important;
  left: 0 !important;
}
</style>
